import React from 'react'
import { useTable, useSortBy } from 'react-table'

import TableHeader from '../shared/TableHeader'
import TableBody from '../shared/TableBody'

const Table = ({
    name,
    columns,
    data,
    loading,
    initialSort,
    initialSortDesc,
    containerClass,
    canClick,
}) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        rows,
        // Get the state from the instance
    } = useTable(
        {
            columns,
            data,
            initialState: {
                pageIndex: 0,
                sortBy: [{
                    id: initialSort,
                    desc: initialSortDesc
                }],
                hiddenColumns: ['FacilityID']
            }, // Pass our hoisted table state
        },
        useSortBy,
    )
    // Render the UI for your table
    return (
        <>
            <div
                className={`container table-container is-small ${containerClass ? containerClass : null}`}
            >
                <table
                    {...getTableProps()}
                    className="table is-striped is-fullwidth is-hoverable explorerTable"
                >
                    <TableHeader headerGroups={headerGroups} />
                    <TableBody
                        {...{
                            getTableBodyProps,
                            page: rows,
                            prepareRow,
                            loading,
                            canClick,
                        }}
                    />
                </table>
            </div>
        </>
    )
}

export default Table
